module.exports = __webpack_public_path__ + "static/media/coimbra-2.d8d08eb6.jpg";